<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
        :additionalSaveFunction="formatAmountReserveBeforeSave"
        :useAdditionalSaveFunction="true"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="SourceOfReserve"
                        :label="$t('lang_LABEL_CONTRACTS_RESERVES_SOURCE')"
                        :withMargin="false"
                        rules="required"
                        :alvqa="alvqa + '-textfield-source-of-reserve'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="EnteredOn"
                        :label="$t('lang_LABEL_CONTRACTS_RESERVES_ENTERED')"
                        :withMargin="false"
                        :alvqa="alvqa + '-datepicker-entered-on'"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Amount"
                        :label="$t('lang_GENERIC_CAPTION_AMOUNT')"
                        :withMargin="false"
                        rules="required|amountMaxTwoDigits"
                        :alvqa="alvqa + '-textfield-amount'"
                        :suffix="$store.getters.getSelectedCurrency"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Reserve"
                        :label="$t('lang_LABEL_CONTRACTS_CAPTION_RESERVE')"
                        :withMargin="false"
                        rules="required|amountMaxTwoDigits"
                        :alvqa="alvqa + '-textfield-reserve'"
                        :suffix="$store.getters.getSelectedCurrency"
                    />
                </v-col>
            </v-row>
            <v-row align="center">
                    <!-- SetUpAccrualsIn -->
                    <BasePeriod 
                        :context="context+'SetUp'"
                        periodLabel="lang_LABEL_CONTRACTS_CAPTION_SETUP_ACCRUALS_IN"
                        :undefinedTimeUnit="true"
                        :widthNumberField="2"
                        :clearable="false"
                    />
                    <!-- ReverseAccrualsIn -->
                    <BasePeriod 
                        :context="context"
                        periodLabel="lang_LABEL_CONTRACTS_CAPTION_REVERSE_ACCRUALS_IN"
                        :undefinedTimeUnit="true"
                        :widthNumberField="2"
                        :clearable="false"
                    />
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BasePeriod from '@/components/_base/BasePeriod'

export default {
    name: "LabelContractsReservesEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
        BaseEditPageDatePicker,
        BasePeriod
    },
    data() {
        return {
            context: 'LabelContractsReserves',
            alvqa: "contracts-label-edit-form-panel-reserves-editing-dialog"
        }
    },
    methods: {
        formatAmountReserveBeforeSave(item) {
            item.amount = this.$alvPlugin.stringToFloat(item.amount)
            item.reserve = this.$alvPlugin.stringToFloat(item.reserve)

            return item
        },
    }
}
</script>